import { GenericValue, HisUploadFile } from 'hisng';

export class PublicationDocumentMetadata {
    id: number;
    title: string;
    access: GenericValue;
    accessAfterEmbargoDate: GenericValue;
    license: GenericValue;
    embargoDate: Date;
    documents: HisUploadFile[];
}
